




















import {
  defineComponent,
  computed
} from '@nuxtjs/composition-api';

const iconList = {
  'Mye for pengene': {
    label: 'Mye for pengene',
    color: '#0091D3',
    icon: '/product-icons/myeforpengene.png'
  },
  'Foodtech\'nology': {
    label: 'Foodtech\'nology',
    color: '#0091A6',
    icon: '/product-icons/foodtechnology.png'
  },
  'Miljø': {
    label: 'Miljø',
    color: '#7FBA27',
    icon: '/product-icons/miljo.png'
  },
  'Bestselger': {
    label: 'Bestselger',
    color: '#B9348A',
    icon: '/product-icons/bestselger.png'
  },
  'Toppmodell': {
    label: 'Toppmodell',
    color: '#F7AC48',
    icon: '/product-icons/toppmodell.png'
  },
  'Rask levering': {
    label: 'Rask levering',
    color: '#733088',
    icon: '/product-icons/rasklevering.png'
  },
  'Matvaregodkjent': {
    label: 'Matvaregodkjent',
    color: '#414042',
    icon: '/product-icons/matvaregodkjent.png'
  },
}

export default defineComponent({
  name: 'ProductIcons',
  props: {
    icons: {
      type: String,
      required: true
    }
  },
  setup (props) {
    const symbols = computed(() => {
      if (!props.icons.length) return []
      const symbolNames = props.icons.split(',').map(symbol => symbol.trim());
      return symbolNames.flatMap(symbol => iconList[symbol] || [])
    })

    return {
      symbols
    }
  }
})
